export const analytics = {
  track: (eventName: string, properties?: Record<string, any>) => {
    // Minimal analytics tracking - could be enhanced with actual analytics service
    console.log("Analytics event:", eventName, properties);
  },
  trackWebEvent: async (
    eventName: string,
    properties?: Record<string, any>
  ) => {
    // Minimal web event tracking - could be enhanced with actual analytics service
    console.log("Web Analytics event:", eventName, properties);
    return Promise.resolve();
  },
  flush: () => {
    // Minimal flush implementation - could be enhanced with actual analytics service
    console.log("Analytics flush");
  },
};
